/**
 * @jest-environment jsdom
 */

 import React from 'react';
 import renderer from 'react-test-renderer';
 import CategoryMenu from './';


 it('renders correctly', () => {
   const tree = renderer.create(<CategoryMenu />).toJSON();
   expect(tree).toMatchSnapshot();
 });



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/CategoryMenu/index.test.jsx